export const IncorrectIcon = () => {
    return (
        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.43107 18.9311C-0.673033 14.827 -0.673033 8.17297 3.43107 4.06887C7.53513 -0.035193 14.1892 -0.0352305 18.2933 4.06887C22.3974 8.17293 22.3974 14.8271 18.2933 18.9311C14.1892 23.0352 7.53513 23.0352 3.43107 18.9311ZM8.63286 7.78444C8.22245 7.37403 7.55705 7.37401 7.14663 7.78444C6.73621 8.19486 6.73623 8.86026 7.14663 9.27066L9.37597 11.5L7.14663 13.7293C6.73623 14.1397 6.73621 14.8051 7.14663 15.2156C7.55705 15.626 8.22245 15.626 8.63286 15.2156L10.8622 12.9862L13.0915 15.2156C13.502 15.626 14.1673 15.626 14.5778 15.2156C14.9882 14.8051 14.9882 14.1398 14.5778 13.7293L12.3484 11.5L14.5778 9.27066C14.9882 8.86024 14.9882 8.19486 14.5778 7.78444C14.1673 7.37401 13.502 7.37401 13.0915 7.78443L10.8622 10.0138L8.63286 7.78444Z"
                fill="url(#paint0_linear_3_918)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_918"
                    x1="-4.00006"
                    y1="11.5"
                    x2="25.7245"
                    y2="11.5"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.114583" stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.5" />
                </linearGradient>
            </defs>
        </svg>
    );
};
